// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"965":"96fcb6b3","4728":"2f9f8ff6","6900":"f9350a64"}[chunkId] + ".chunk.css";
};